module.exports = __webpack_public_path__ + "static/media/sales-order-slide-11.0c215edb.jpg";